import { FormControl, FormLabel, Icon, Input, InputGroup, InputLeftAddon, InputRightAddon, Stack } from "@chakra-ui/react";
import { IBESZLA_PUB } from "@coimbra-its/api.konyvelo";
import { formatDate, formatNumber, useWSysPage, WSysPage, WSysVert } from "@coimbra-its/websys-ux-core";
import { APPICONS } from "../Icons";



export function SzamlaDetails({ szamla }: { szamla: IBESZLA_PUB }) {

    const page = useWSysPage({
        title: 'Részletek', maxCols: 2, variant: 'attach'
        //, wsStyle: 'inverted'
    });

    return <WSysPage page={page} borderLeft='2px solid #2c6195'>
        <WSysVert mode="static" isInverted={false}>
            <Stack p={2}>
                <FormControl>
                    <FormLabel>Szállító neve</FormLabel>
                    <InputGroup>
                        <InputLeftAddon pr={2}><Icon opacity='.5' as={APPICONS.User} /></InputLeftAddon>
                        <Input value={szamla.P_NEV || ''} onChange={() => { }} readOnly={true} />
                        <InputRightAddon opacity={.6} >{szamla.P_KOD || ''}</InputRightAddon>
                    </InputGroup>
                </FormControl>

                <FormControl>
                    <FormLabel>Számlaszám</FormLabel>
                    <Input value={szamla.SZLASZ || ''} onChange={() => { }} readOnly={true} />
                </FormControl>

            </Stack>
        </WSysVert>

        <WSysVert mode="rest" isInverted={false}>
            <Stack p={2}>
                <FormControl>
                    <FormLabel>Számla dátuma</FormLabel>
                    <Input value={formatDate(szamla.SZLADAT)} onChange={() => { }} readOnly={true} />
                </FormControl>

                <FormControl>
                    <FormLabel>Teljesítés dátuma</FormLabel>
                    <Input value={formatDate(szamla.TELJDAT)} onChange={() => { }} readOnly={true} />
                </FormControl>

                <FormControl>
                    <FormLabel>Fizetési határidő</FormLabel>
                    <Input value={formatDate(szamla.FHATDAT)} onChange={() => { }} readOnly={true} />
                </FormControl>

                <FormControl>
                    <FormLabel>Fizetési mód</FormLabel>
                    <Input value={szamla.FIZMOD || ''} onChange={() => { }} readOnly={true} />
                </FormControl>
                <FormControl>
                    <FormLabel>Nettó</FormLabel>
                    <InputGroup>
                        <Input value={formatNumber(szamla.NETTO)} onChange={() => { }} readOnly={true} textAlign='right' />
                        <InputRightAddon>&nbsp;Ft</InputRightAddon>
                    </InputGroup>
                </FormControl>
                <FormControl>
                    <FormLabel>ÁFA</FormLabel>
                    <InputGroup>
                        <Input value={formatNumber(szamla.AFA)} onChange={() => { }} readOnly={true} textAlign='right' />
                        <InputRightAddon>&nbsp;Ft</InputRightAddon>
                    </InputGroup>
                </FormControl>
                <FormControl>
                    <FormLabel>Brutto</FormLabel>
                    <InputGroup>
                        <Input value={formatNumber(szamla.BRUTTO)} onChange={() => { }} readOnly={true} textAlign='right' />
                        <InputRightAddon>&nbsp;Ft</InputRightAddon>
                    </InputGroup>
                </FormControl>
                {/* !!!!!!!!!!!!!!!!!!!!! TODO: DEVIZÁS ÉRTÉKEK!!!!!!!!!!!!!!!!!!!!!!!!!!! */}
                {szamla.DEV !== 'HUF' && <>
                    <FormControl>
                        <FormLabel>Nettó</FormLabel>
                        <InputGroup>
                            <Input value={formatNumber(szamla.DEV_NETTO)} onChange={() => { }} readOnly={true} textAlign='right' />
                            <InputRightAddon>&nbsp;{(szamla.DEV === 'HUF' ? 'Ft' : szamla.DEV)}</InputRightAddon>
                        </InputGroup>
                    </FormControl>
                    <FormControl>
                        <FormLabel>ÁFA</FormLabel>
                        <InputGroup>
                            <Input value={formatNumber(szamla.DEV_AFA)} onChange={() => { }} readOnly={true} textAlign='right' />
                            <InputRightAddon>&nbsp;{(szamla.DEV === 'HUF' ? 'Ft' : szamla.DEV)}</InputRightAddon>
                        </InputGroup>
                    </FormControl>
                    <FormControl>
                        <FormLabel>Brutto</FormLabel>
                        <InputGroup>
                            <Input value={formatNumber(szamla.DEV_BRUTTO)} onChange={() => { }} readOnly={true} textAlign='right' />
                            <InputRightAddon>&nbsp;{(szamla.DEV === 'HUF' ? 'Ft' : szamla.DEV)}</InputRightAddon>
                        </InputGroup>
                    </FormControl>
                </>}
            </Stack>
        </WSysVert>
    </WSysPage >
}